export const APP_NAME = "Angaza Music";
export const APP_DESCRIPTION = "Stream all your favourite gospel music";
export const APP_URL = "https://angazamusic.co.ke";
export const APP_IMAGE = "https://angazamusic.co.ke/app-icons/android-chrome-192x192.png";
